export default __webpack_public_path__ + "fcdfef99d41b2aa3c3734181593e63c1.png";